import React from 'react';
import { Row, Col, Card, Stack } from 'react-bootstrap';
import 'assets/styles/common.scss';
import 'Pages/Doctor/DoctorDashboard/doctorDashboard.scss';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import Shimmer from 'components/commom/Shimmer';

const DashboardCardData = () => {
  const loading = useSelector((state) => state?.getDashboardReducer?.loading);

  const dashboardDetail = useSelector(
    (state) => state?.getDashboardReducer?.users?.data
  );

  return (
    <div>
      <h2 className="fc-292D32 fs-32 family_outfit_semiBold_600  m-0">
        <FormattedMessage id="Dashboard" />
      </h2>

      <Row className="mt-3 ">
        <Col lg={4} xl={3} md={6} sm={12}>
          <Card className={'text-start dashboard-card '}>
            <Card.Body>
              <Stack direction="horizontal" gap={2} className="items-center">
                <div className="fs-16 fc-998A7B family_outfit_regular_400">
                  <FormattedMessage id="New Appointment Requests" />
                </div>
              </Stack>
              <div className="fs-28 fc-3C3C3C family_outfit_regular_500 mt-2">
                {loading ? (
                  <Shimmer width="250px" height="20px" />
                ) : (
                  dashboardDetail?.new_requests_count
                )}
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col lg={4} xl={3} md={6} sm={12}>
          <Card className={'text-start dashboard-card'}>
            <Card.Body>
              <Stack direction="horizontal" gap={2} className="items-center">
                <div className="fs-16 fc-998A7B family_outfit_regular_400">
                  <FormattedMessage id="All Patients" />
                </div>
              </Stack>
              <div className="fs-28 fc-3C3C3C family_outfit_regular_500 mt-2">
                {loading ? (
                  <Shimmer width="250px" height="20px" />
                ) : (
                  dashboardDetail?.all_patients_count
                )}
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default DashboardCardData;
